import styled from 'styled-components'
import { belowPhone } from 'utilities/styled'
import BadgeBase from 'components/badge'
import { Plain } from 'components/button'

export const Badge = styled(BadgeBase)`
    display: inline-grid;

    margin-inline-end: 8px;

    transition: background-color .15s ease-in;
`

export const ToggleButton = styled(Plain)`
    .text {
        ${belowPhone`
            display: none;
        `}
    }

    &:not(:disabled):where(:hover, :focus) {
        text-decoration: none;

        .text {
            text-decoration: underline;
        }
    }
`